// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"381ce2f4","198":"6e197dc2","498":"caf7ae3c","703":"06b9e562"}[chunkId] + ".chunk.js";
};